import { connect } from 'react-redux'
// import React from 'react'
// import PropTypes from 'prop-types'
import R from 'ramda'
import { PAGES } from '../../constants'

import { setNavigation } from '_actions'

import Fastspring from './page'

const mapStateToProps = state => ({
  fastspringPage: R.pathOr({}, ['pages', PAGES.FASTSPRING], state)
})

const mapDispatchToProps = dispatch => ({
  // actions
  goToPage: R.compose(dispatch, setNavigation, R.merge(R.__, {pageName: PAGES.FASTSPRING})) // navigation
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Fastspring)



// WEBPACK FOOTER //
// ./webAdmin/components/fastspring/index.js